import { useCallback } from 'react';
import { useUser } from 'features/auth';

export const useBindViewer = () => {
  const user = useUser({ requiredAuth: false });

  return useCallback(
    <A, P extends { viewer: A }>(bindFunction: (argument: P) => boolean) =>
      (params: Omit<P, 'viewer'>): boolean =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        user ? bindFunction({ ...params, viewer: user } as P) : false,
    [user],
  );
};
